// extracted by mini-css-extract-plugin
export var actions = "_3m-0";
export var actionsContainer = "_3m-6";
export var border = "_3m-1";
export var childFullHeight = "_3m-d";
export var collapse = "_3m-2";
export var content = "_3m-8";
export var contentChild = "_3m-c";
export var fullscreen = "_3m-a";
export var headerContainer = "_3m-3";
export var headerRow = "_3m-5";
export var hidePadding = "_3m-9";
export var noScrollX = "_3m-e";
export var noScrollY = "_3m-f";
export var optOutTopPadding = "_3m-b";
export var pagePadding = "_3m-7";
export var profile = "_3m-g";
export var profileContainer = "_3m-h";
export var profileImage = "_3m-i";
export var profileMain = "_3m-j";
export var profileSubtitle = "_3m-l";
export var profileTitle = "_3m-k";
export var tabsWrapper = "_3m-4";
export var title = "_3m-m";